module.exports = __webpack_public_path__ + "images/icon/icn_duplicate_collection_hover-e599bb9c.svg";